export type TranscriptSpeakerPlatformHostSource = {
  isPlatformHost?: unknown;
  is_platform_host?: unknown;
  isHost?: unknown;
  is_host?: unknown;
};

export type ResolveTranscriptSpeakerIsPlatformHostArgs = {
  source: TranscriptSpeakerPlatformHostSource | null | undefined;
};

const asBoolean = (value: unknown): boolean | undefined =>
  typeof value === "boolean" ? value : undefined;

/**
 * Resolve the meeting-platform host role from canonical fields first, while
 * tolerating legacy aliases from older local transcript metadata.
 *
 * The returned value describes only the meeting provider's host role. It must
 * not be used to infer local speaker identity, audio source, or Mem account
 * ownership.
 */
export function resolveTranscriptSpeakerIsPlatformHost({
  source,
}: ResolveTranscriptSpeakerIsPlatformHostArgs): boolean | undefined {
  if (!source) return undefined;

  return (
    asBoolean(source.isPlatformHost) ??
    asBoolean(source.is_platform_host) ??
    asBoolean(source.isHost) ??
    asBoolean(source.is_host)
  );
}
